/**
 * Updates a query search parameter and changes url
 * @param {*} param The parameter to change
 * @param {*} value The new value
 */
export const updateUrlSearch = (param, value) => {
  let parts = window.location.search.split(/\?|&/);
  let found = false;
  let newSearch = parts.reduce((s, cur) => {
    if (cur) {
      let [key, paramValue] = cur.split('=');
      if (key == param) {
        found = true;
        paramValue = value;
      }
      s.push(`${key}=${paramValue}`);
    }
    return s;
  }, []);

  // add key manually if not found
  if (!found) {
    newSearch.push(`${param}=${encodeURIComponent(value)}`);
  }

  // only update search if we have data
  if (newSearch.length > 0) {
    window.location.search = `?${newSearch.join('&')}`;
  }
}

export const getScreenOrientation = () => {
  return ($(window).width() > $(window).height()) ? 90 : 0;
}

export const mod = (n, m) => {
  return ((n % m) + m) % m;
}

/**
 * Frappe image upload helper. Calls the frappe image upload functionality. Call
 * returns the File doctype information after a successful upload.
 * @param {*} file A file object. Ex: { file_obj: <blob>, name: string }
 * @param {*} is_private (Optional) When true the file is only available to on the backend. Default false
 * @param {*} folder (Optional) A location folder for the image(virtual)
 * @param {*} doctype (Optional) A doctype to attach this file
 * @param {*} docname (Optional) A doctype name to attach this file
 * @param {*} method (Optional) method to call after upload.
 */
export const uploadFile = (file, is_private, folder, doctype, docname, method) => {
  return new Promise((resolve, reject) => {
    let xhr = new XMLHttpRequest();

    xhr.upload.addEventListener('loadstart', (e) => {
      file.uploading = true;
    });

    xhr.upload.addEventListener('progress', (e) => {
      if (e.lengthComputable) {
        file.progress = e.loaded;
        file.total = e.total;
      }
    });

    xhr.upload.addEventListener('load', (e) => {
      file.uploading = false;
    });

    xhr.addEventListener('error', (e) => {
      file.failed = true;
      reject();
    });

    xhr.onreadystatechange = () => {
      if (xhr.readyState == XMLHttpRequest.DONE) {
        if (xhr.status === 200) {
          let r = null;
          let file_doc = null;
          try {
            r = JSON.parse(xhr.responseText);
            if (r.message.doctype === 'File') {
              file_doc = r.message;
            }
          } catch (e) {
            r = xhr.responseText;
          }

          file.doc = file_doc;
          file.doc.file_name = file.name;
          resolve(file_doc);
        } else if (xhr.status === 403) {
          let response = JSON.parse(xhr.responseText);
          frappe.msgprint({
            title: __('Not permitted'),
            indicator: 'red',
            message: response._error_message
          });
        } else {
          file.failed = true;
          let error = null;
          try {
            error = JSON.parse(xhr.responseText);
          } catch (e) {
            // pass
          }
          frappe.request.cleanup({}, error);
        }
      }
    };

    xhr.open('POST', '/api/method/upload_file', true);
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.setRequestHeader('X-Frappe-CSRF-Token', frappe.csrf_token);

    let form_data = new FormData();

    if (file.file_obj) {
      form_data.append('file', file.file_obj, file.name);
    }
    form_data.append('is_private', +file.private);
    form_data.append('folder', folder);

    if (file.file_url) {
      form_data.append('file_url', file.file_url);
    }

    if (doctype && docname) {
      form_data.append('doctype', doctype);
      form_data.append('docname', docname);
    }

    if (method) {
      form_data.append('method', method);
    }

    xhr.send(form_data);
  });
}

/**
 * Simple component manager. All it does is keep references to components and help
 * broadcast method calls.
 */
export class ComponentManager {
  constructor() {
    this.components = {};
  }

  /**
   * Adds a component to manage its lifecycle
   * @param {string} name Component name
   * @param {object} component The component instance
   */
  add(name, component) {
    Reflect.set(this.components, name, component);
    return this;
  }

  /**
   * Gets a component by its name
   * @param {string} name Component name
   */
  get(name) {
    return Reflect.get(this.components, name);
  }

  /** Returns true if component is found */
  has(name) {
    return Reflect.has(this.components, name);
  }

  /**
   * Broadcasts the init method call on all components.
   */
  async init(...args) {
    await this.asyncBroadcast("init", ...args);
  }

  /**
   * Calls a method on all components.
   * @param {*} method The method name
   * @param {...any} args arguments to pass into method call.
   */
  broadcast(method, ...args) {
    for (let component of Object.values(this.components)) {
      if (Reflect.has(component, method)) {
        let methodRef = Reflect.get(component, method);
        methodRef.apply(component, args);
      }
    }
  }

  /**
   * Calls a method on all components.
   * @param {*} method The method name
   * @param {...any} args arguments to pass into method call.
   */
  async asyncBroadcast(method, ...args) {
    console.log("-- EVENT -- ", method, this);
    for (let [name, component] of Object.entries(this.components)) {
      console.groupCollapsed("[BROADCAST] ", component.constructor.name, method);
      console.dir(...args);
      console.groupEnd();
      if (Reflect.has(component, method)) {
        let methodRef = Reflect.get(component, method);
        await Promise.resolve(methodRef.apply(component, args));
      }
    }
  }
}

export class DomApi {
  constructor(parent, $el) {
    this.parent = parent;
    this.$el = $el
  }

  get id() {
    return this.$el.attr('id');
  }

  on(event, callback) {
    this.$el.on(event, callback);
  }

  trigger(event, args) {
    this.$el.trigger(event, args);
  }
}

export async function asyncSleep(timeout) {
  return await new Promise((resolve) => {
    setTimeout(resolve, timeout);
  });
}